<template>
  <div :class="componentClasses">
    <label class="stk-toggle-label">
      <input 
        class="stk-toggle-input" 
        type="checkbox" 
        :checked="modelValue" 
        @change="toggleSwitch"
      >
      <span class="stk-toggle-slider">
        <Loader v-if="loading" />
      </span>
    </label>
    <slot />
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import Loader from '@stakeui/graphic/loader/Loader.vue';

const props = defineProps({
  modelValue: Boolean,
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const toggleSwitch = (event) => {
  emit("update:modelValue", event.target.checked);
};

const componentClasses = computed(() => [
  'stk-toggle',
  props.modelValue ? 'is-checked' : '',
  props.loading ? 'is-loading' : '',
]);
</script>

<style>
.stk-toggle {
  align-items: center;
  display: inline-flex;
  gap: 0.5em;
  vertical-align: top;
}

.stk-toggle-label {
  background-color: var(--stk-border);
  border-radius: 9999px;
  cursor: pointer;
  display: inline-flex;
  padding: 0.25em;
  position: relative;
  width: 2.5em;
}

.stk-toggle-input {
  opacity: 0;
  height: 0;
  width: 0;
}

.stk-toggle-slider {
  background-color: var(--stk-text-weak);
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  height: 1em;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color, transform;
  width: 1em;
}

/* Loading state */
.stk-toggle.is-loading .stk-toggle-slider {
  background-color: transparent !important;
}

/* Checked state */
.stk-toggle.is-checked .stk-toggle-label {
  background-color: var(--stk-primary-85);
}

.stk-toggle.is-checked .stk-toggle-slider {
  background-color: var(--stk-primary);
  transform: translateX(1em);
}
</style>
